/* import __COLOCATED_TEMPLATE__ from './watch-how-to-use-articles-video.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();